<template>
  <transition name="fade">
    <div class="long-work-wrap ml-4 mb-4" v-if="currentTask" :class="{ hover }">
      <v-alert
        prominent
        text
        color="indigo"
        class="mb-0"
        @mouseenter="hover = true"
        @mouseleave="hover = false"
      >
        <strong class="ml-4 long-work-message" v-show="hover">
          {{ currentTask.message }}</strong
        >
        <template #prepend>
          <v-progress-circular
            indeterminate
            color="indigo"
          ></v-progress-circular>
        </template>
      </v-alert>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    taskQueue: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      hover: false,
    };
  },
  computed: {
    currentTask() {
      return this.taskQueue[0];
    },
  },
  watch: {
    currentTask(task) {
      if (task) {
        this.hover = true;
        setTimeout(() => {
          this.hover = false;
        }, 5000);
        task.work();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.long-work-wrap {
  position: fixed;
  bottom: 0;
  left: 0;
  border-radius: 10px;
  box-sizing: content-box;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 999999999999999999999;
  box-shadow: 0 3px 5px -1px rgb(0 0 0 / 20%), 0 6px 10px 0 rgb(0 0 0 / 14%),
    0 1px 18px 0 rgb(0 0 0 / 12%);
  font-weight: bold;
  transition: all 0.3s ease-out;
  overflow: hidden;
  &.hover {
    background-color: rgba(255, 255, 255, 1);
    box-shadow: none;
    transform: translateY(-5px);
  }
}

.fade-enter, .fade-leave /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  bottom: -50px;
}
</style>
